// blogPostsSet11.js - Artículos 151-153 (keywords AnswerThePublic)

export const blogPostsSet11 = [
  {
    id: 151,
    title: "¿Contar Calorías es Malo? Cuándo Ayuda y Cuándo Conviene Parar",
    slug: "contar-calorias-es-malo-verdad",
    author: "Wayo Nutrition Team",
    date: "2026-02-16",
    readTime: "12 min",
    category: "Nutrición",
    image: "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=1200",
    excerpt: "¿Contar calorías es malo para tu salud mental? ¿Funciona realmente? Analizamos los pros, contras y cuándo es buena idea hacerlo (y cuándo no).",
    metaDescription: "Descubre cuándo contar calorías puede ayudarte a mejorar tu alimentación, cuándo puede volverse obsesivo y qué alternativas más simples tienes.",
    keywords: ["contar calorías es malo", "contar calorías", "es malo contar calorías", "obsesión calorías", "dejar de contar calorías"],
    tags: ["calorías", "salud mental", "nutrición", "dieta"],
    content: `
      <div class="blog-article-extended">
        <h2>¿Contar Calorías es Malo? Depende</h2>
        <p>Si buscas "contar calorías es malo", probablemente estás en uno de estos dos bandos: o llevas tiempo contando y te sientes obsesionado, o alguien te dijo que deberías hacerlo y no estás seguro.</p>

        <p>La respuesta corta: <strong>contar calorías NO es malo en sí mismo</strong>. Pero CÓMO lo haces puede serlo. Vamos a explicarlo.</p>

        <div class="info-box">
          <h3>⚡ Resumen Rápido</h3>
          <ul>
            <li>Contar calorías es una herramienta, no un estilo de vida</li>
            <li>Es útil para aprender sobre porciones y nutrientes</li>
            <li>Puede ser perjudicial si genera ansiedad u obsesión</li>
            <li>Las apps con IA como Wayo lo hacen mucho más fácil y menos estresante</li>
          </ul>
        </div>

        <h2>Cuándo Contar Calorías SÍ es Buena Idea</h2>

        <h3>1. Cuando estás empezando a cuidar tu alimentación</h3>
        <p>La mayoría de personas no tiene ni idea de cuántas calorías come al día. Contar durante 2-4 semanas te da una <strong>educación nutricional</strong> que vale oro. Aprendes que un plato de pasta con salsa carbonara tiene 800 kcal, o que una ensalada con aceite puede tener más calorías que un bocadillo.</p>

        <h3>2. Cuando tienes un objetivo claro</h3>
        <p>Si quieres perder peso, ganar músculo o preparar una competición, contar calorías te da <strong>datos reales</strong> en lugar de suposiciones. Sin datos, es como intentar ahorrar dinero sin mirar tu cuenta bancaria.</p>

        <h3>3. Cuando lo haces con herramientas simples</h3>
        <p>Contar calorías en 2026 no es lo mismo que en 2010. Ya no necesitas pesar cada alimento con báscula y buscar tablas nutricionales. Apps como <strong>Wayo</strong> te permiten <strong>hacer una foto a tu plato</strong> y tener las calorías y macros al instante.</p>

        <h2>Cuándo Contar Calorías es MALA Idea</h2>

        <h3>1. Si te genera ansiedad</h3>
        <p>Si rechazas salir a cenar porque "no puedes contar las calorías del restaurante", o si te sientes culpable por pasarte 100 calorías, es momento de parar. La comida debería nutrirte, no estresarte.</p>

        <h3>2. Si tienes antecedentes de trastornos alimentarios</h3>
        <p>Personas con historial de anorexia, bulimia o trastorno por atracón deberían <strong>evitar contar calorías</strong> salvo indicación de un profesional. En estos casos, puede reforzar comportamientos dañinos.</p>

        <h3>3. Si llevas más de 6 meses contando sin parar</h3>
        <p>Contar calorías es una fase de aprendizaje, no un modo de vida permanente. Después de unos meses, deberías tener suficiente intuición para estimar porciones sin necesidad de registrar cada gramo.</p>

        <h2>La Alternativa: Contar Calorías Sin Obsesionarte</h2>
        <p>El problema no es contar calorías. El problema es <strong>cómo</strong> se ha hecho tradicionalmente: pesando alimentos, buscando en bases de datos, anotando cada bocado.</p>

        <p>La solución moderna es usar <strong>inteligencia artificial</strong>. Con Wayo:</p>
        <ul>
          <li>Haces una foto a tu plato y ya está</li>
          <li>No necesitas pesar nada</li>
          <li>La app te dice si vas bien o mal respecto a tu objetivo</li>
          <li>Te avisa si te faltan proteínas, verduras o nutrientes</li>
          <li>Si un día no registras, no pasa nada</li>
        </ul>

        <h2>¿Qué Dicen los Estudios?</h2>
        <p>La ciencia es clara: las personas que <strong>registran su alimentación</strong> pierden más peso que las que no lo hacen. Un estudio del American Journal of Preventive Medicine encontró que quienes llevan un registro pierden el doble de peso.</p>

        <p>Pero también hay estudios que muestran que el registro obsesivo puede contribuir a trastornos alimentarios en personas susceptibles. La clave está en el <strong>equilibrio</strong>.</p>

        <h2>Consejos Para Contar Calorías de Forma Saludable</h2>
        <ol>
          <li><strong>Ponle un plazo:</strong> Cuenta durante 4-8 semanas, luego descansa</li>
          <li><strong>No busques perfección:</strong> Un margen de ±200 calorías está bien</li>
          <li><strong>Usa herramientas simples:</strong> Apps con foto como Wayo, no básculas</li>
          <li><strong>No compenses:</strong> Si un día comes más, no ayunes al siguiente</li>
          <li><strong>Aprende patrones:</strong> El objetivo es que después puedas estimar sin app</li>
        </ol>

        <h2>Conclusión</h2>
        <p>Contar calorías <strong>no es malo</strong>. Es una herramienta educativa muy potente. Pero como cualquier herramienta, hay que saber cuándo usarla y cuándo dejarla.</p>

        <p>Si nunca lo has hecho, pruébalo unas semanas con una app simple. Si llevas meses y te genera estrés, es momento de soltar y confiar en lo que has aprendido.</p>

        <div class="cta-box">
          <h3>📸 Cuenta Calorías Sin Estrés con Wayo</h3>
          <p>Haz una foto a tu comida y <strong>Wayo</strong> calcula calorías y macros automáticamente. Sin pesar, sin escribir, sin obsesionarte.</p>
          <p><a href="https://wayoai.app/download" class="cta-button">Prueba Wayo Gratis</a></p>
        </div>
      </div>
    `
  },
  {
    id: 152,
    title: "¿Qué Pasa si Como 1.500 Calorías al Día? Efectos Reales en tu Cuerpo",
    seoTitle: "¿1.500 Calorías al Día Es Mucho o Poco? Depende de Esto",
    slug: "que-pasa-si-como-1500-calorias-al-dia",
    author: "Wayo Nutrition Team",
    date: "2026-02-15",
    readTime: "13 min",
    category: "Pérdida de Peso",
    image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=1200",
    excerpt: "¿1500 calorías al día es poco o suficiente? Analizamos qué le pasa a tu cuerpo, cuánto peso puedes perder y si es seguro para ti.",
    metaDescription: "¿1.500 kcal al día es poco o está bien? Para quién funciona, para quién se queda corto, cuánto peso se pierde y las señales de que te estás pasando.",
    keywords: ["1500 calorías al día", "qué pasa si como 1500 calorías", "dieta 1500 calorías", "es mucho 1500 calorías", "1500 calorías es poco"],
    tags: ["calorías", "pérdida de peso", "déficit calórico", "dieta"],
    content: `
      <div class="blog-article-extended">
        <h2>1500 Calorías al Día: ¿Es Mucho o Poco?</h2>
        <p><strong>1500 calorías al día</strong> es una de las cifras más buscadas en nutrición. Y la respuesta depende completamente de quién eres tú.</p>

        <p>Para una mujer sedentaria de 55 kg, 1500 calorías puede ser su mantenimiento. Para un hombre activo de 85 kg, es un déficit agresivo. El contexto lo es todo.</p>

        <div class="info-box">
          <h3>⚡ La Respuesta Rápida</h3>
          <ul>
            <li>Para la mayoría de mujeres: es un déficit moderado → perderás peso</li>
            <li>Para la mayoría de hombres: es un déficit grande → podrías perder músculo</li>
            <li>Mínimo recomendado: 1200 kcal mujeres, 1500 kcal hombres</li>
            <li>Lo ideal: <a href="/blog/cuantas-calorias-consumir-al-dia-calculadora">calcular TU mantenimiento</a> y restar 300-500 kcal</li>
          </ul>
        </div>

        <h2>¿Cuánto Peso Pierdes con 1500 Calorías al Día?</h2>

        <h3>Ejemplo: Mujer de 65 kg, moderadamente activa</h3>
        <p>Mantenimiento estimado: ~2000 kcal/día</p>
        <ul>
          <li>Déficit diario: 500 kcal</li>
          <li>Déficit semanal: 3500 kcal</li>
          <li><strong>Pérdida estimada: ~0.5 kg por semana</strong></li>
          <li>En 3 meses: ~6 kg</li>
        </ul>

        <h3>Ejemplo: Hombre de 80 kg, activo</h3>
        <p>Mantenimiento estimado: ~2800 kcal/día</p>
        <ul>
          <li>Déficit diario: 1300 kcal</li>
          <li>Déficit semanal: 9100 kcal</li>
          <li><strong>Pérdida estimada: ~1.3 kg por semana</strong></li>
          <li>⚠️ Esto es DEMASIADO agresivo → riesgo de perder músculo</li>
        </ul>

        <h2>Efectos Positivos de Comer 1500 Calorías</h2>
        <ul>
          <li><strong>Pérdida de peso:</strong> Si estás en déficit, perderás grasa</li>
          <li><strong>Mejor relación con la comida:</strong> Te obliga a elegir mejor</li>
          <li><strong>Más energía:</strong> Si antes comías mucha comida procesada, comerás más nutrientes con menos calorías</li>
          <li><strong>Mejor digestión:</strong> Menos cantidad = menos trabajo digestivo</li>
        </ul>

        <h2>Efectos Negativos (Si No Es Para Ti)</h2>
        <ul>
          <li><strong>Hambre constante:</strong> Si tu mantenimiento es muy alto, 1500 será insostenible</li>
          <li><strong>Pérdida de músculo:</strong> Si el déficit es mayor a 500-750 kcal, pierdes músculo junto con grasa</li>
          <li><strong>Metabolismo más lento:</strong> Déficits muy grandes durante mucho tiempo bajan tu metabolismo</li>
          <li><strong>Falta de energía:</strong> Especialmente si entrenas fuerte</li>
          <li><strong>Caída de pelo, uñas frágiles:</strong> Señales de déficit nutricional</li>
        </ul>

        <h2>¿Para Quién Son Adecuadas 1500 Calorías?</h2>

        <table class="comparison-table">
          <thead>
            <tr>
              <th>Perfil</th>
              <th>¿1500 kcal es adecuado?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Mujer sedentaria (50-65 kg)</td>
              <td>✅ Sí, déficit moderado</td>
            </tr>
            <tr>
              <td>Mujer activa (55-70 kg)</td>
              <td>⚠️ Puede ser poco si entrenas</td>
            </tr>
            <tr>
              <td>Hombre sedentario (70-85 kg)</td>
              <td>⚠️ Déficit grande, mejor 1800-2000</td>
            </tr>
            <tr>
              <td>Hombre activo (75-90 kg)</td>
              <td>❌ Demasiado poco, riesgo de perder músculo</td>
            </tr>
            <tr>
              <td>Adolescentes</td>
              <td>❌ No recomendado sin supervisión médica</td>
            </tr>
          </tbody>
        </table>

        <h2>Cómo Hacer que 1500 Calorías Sea Suficiente</h2>
        <p>Si 1500 kcal es adecuado para ti, estos trucos te ayudarán a no pasar hambre:</p>
        <ol>
          <li><strong>Prioriza proteína:</strong> 1.5-2g por kg de peso. Te mantiene saciado y preserva músculo</li>
          <li><strong>Verduras en cada comida:</strong> Volumen con pocas calorías</li>
          <li><strong>Evita calorías líquidas:</strong> Refrescos, zumos, alcohol</li>
          <li><strong>Come alimentos reales:</strong> Menos procesados = más saciedad por caloría</li>
          <li><strong>Distribuye bien las comidas:</strong> 3 comidas de 400-500 kcal o 3 de 350 + 2 snacks</li>
        </ol>

        <h2>Un Día Ejemplo con 1500 Calorías</h2>
        <ul>
          <li><strong>Desayuno (400 kcal):</strong> Tostada integral con aguacate + 2 huevos + café</li>
          <li><strong>Comida (500 kcal):</strong> Pechuga de pollo a la plancha + arroz integral + ensalada</li>
          <li><strong>Merienda (150 kcal):</strong> Yogur griego con frutos rojos</li>
          <li><strong>Cena (450 kcal):</strong> Salmón al horno + verduras asadas</li>
        </ul>

        <h2>Conclusión</h2>
        <p>1500 calorías al día puede ser perfecto para ti o completamente insuficiente. La clave es conocer tu mantenimiento calórico y crear un déficit moderado (300-500 kcal), no elegir un número arbitrario.</p>

        <div class="cta-box">
          <h3>📊 Descubre Tu Déficit Ideal con Wayo</h3>
          <p><strong>Wayo</strong> calcula tu mantenimiento calórico y te dice exactamente cuánto comer para perder peso sin perder músculo.</p>
          <p><a href="https://wayoai.app/download" class="cta-button">Prueba Wayo Gratis</a></p>
        </div>
      </div>
    `
  },
  {
    id: 153,
    title: "5 Mejores Apps para Contar Calorías Gratis en 2026 [¿Cuál Instalar?]",
    slug: "mejores-apps-contar-calorias-gratis-2026",
    seoTitle: "Apps para Contar Calorías Gratis 2026: Qué Bloquea Cada Una",
    author: "Wayo Nutrition Team",
    date: "2026-02-14",
    readTime: "14 min",
    category: "Tecnología",
    image: "https://images.unsplash.com/photo-1556656793-08538906a9f8?w=1200",
    excerpt: "Probamos 5 apps gratuitas para contar calorías en 2026. Esta es la que más tiempo ahorra: MyFitnessPal, Yazio, FatSecret, Lifesum y Wayo comparadas con tabla.",
    metaDescription: "5 apps gratis comparadas por lo que de verdad puedes hacer sin pagar: MyFitnessPal, Yazio, FatSecret, Lifesum y Wayo. Qué entra y qué pide suscripción.",
    keywords: ["mejor app para contar calorías gratis", "mejor app para contar calorías", "apps contar calorías", "mejor aplicación contar calorías", "myfitnesspal gratis", "app calorías gratis 2026"],
    tags: ["apps", "calorías", "comparativa", "tecnología"],
    content: `
      <div class="blog-article-extended">
        <h2>¿Cuál es la Mejor App Para Contar Calorías Gratis?</h2>
        <p>En 2026 hay decenas de apps para contar calorías. Pero no todas son iguales. Algunas cobran por funciones básicas, otras tienen bases de datos incompletas, y muchas te obligan a registrar cada alimento manualmente.</p>

        <p>Hemos probado las 5 más populares para que no tengas que hacerlo tú. Esto es lo que encontramos.</p>

        <div class="info-box">
          <h3>⚡ Top 3 Rápido</h3>
          <ol>
            <li><strong>Wayo</strong> — La más fácil (foto y listo, con IA)</li>
            <li><strong>MyFitnessPal</strong> — La base de datos más grande</li>
            <li><strong>Yazio</strong> — Buen diseño y recetas</li>
          </ol>
        </div>

        <h2>Mejor app para contar calorías gratis: comparativa rápida</h2>
        <p>Si solo quieres una respuesta rápida, la mejor app depende de cómo registras tu comida. Para comida casera o platos mezclados, una app con foto ahorra mucho tiempo. Para productos envasados, una base de datos grande y código de barras puede ser suficiente. Si quieres ver opciones gratis y de pago, empieza por la guía general de <a href="/blog/mejores-apps-contar-calorias-2026">mejores apps para contar calorías en 2026</a>.</p>

        <table class="comparison-table">
          <thead>
            <tr>
              <th>Necesidad</th>
              <th>Mejor opción</th>
              <th>Por qué</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>Contar calorías rápido</td><td>Wayo</td><td>Foto del plato e IA</td></tr>
            <tr><td>Registrar productos envasados</td><td>MyFitnessPal</td><td>Base de datos enorme</td></tr>
            <tr><td>App gratis clásica</td><td>FatSecret</td><td>Funciones básicas sin complicarse</td></tr>
            <tr><td>Planes y recetas</td><td>Yazio</td><td>Buen enfoque visual y recetas</td></tr>
            <tr><td>Diseño premium</td><td>Lifesum</td><td>Experiencia cuidada, pero limitada gratis</td></tr>
          </tbody>
        </table>

        <h2>1. Wayo — Contar Calorías con una Foto</h2>
        <p><strong>Precio:</strong> Gratis (funciones premium opcionales)</p>
        <p><strong>Disponible en:</strong> iOS y Android</p>

        <h3>Lo Mejor</h3>
        <ul>
          <li>Haces una foto a tu plato y la IA reconoce la comida, calorías y macros</li>
          <li>No necesitas buscar alimentos ni pesar nada</li>
          <li>Te dice si tu comida encaja con tus objetivos</li>
          <li>Incluye entrenamientos personalizados y recetario</li>
          <li>Recomendaciones con inteligencia artificial</li>
        </ul>

        <h3>Lo Peor</h3>
        <ul>
          <li>Es más nueva que MyFitnessPal (menos comunidad)</li>
          <li>Algunas funciones avanzadas requieren premium</li>
        </ul>

        <h3>Ideal Para</h3>
        <p>Personas que quieren algo <strong>rápido y simple</strong>. Si odias registrar manualmente cada alimento, Wayo es tu app.</p>

        <h2>2. MyFitnessPal</h2>
        <p><strong>Precio:</strong> Gratis (versión premium: ~9.99€/mes)</p>
        <p><strong>Disponible en:</strong> iOS y Android</p>

        <h3>Lo Mejor</h3>
        <ul>
          <li>Base de datos con más de 14 millones de alimentos</li>
          <li>Escáner de código de barras</li>
          <li>Se integra con muchos wearables</li>
          <li>Comunidad grande y activa</li>
        </ul>

        <h3>Lo Peor</h3>
        <ul>
          <li>La versión gratuita ahora tiene muchas limitaciones</li>
          <li>La interfaz se ha vuelto más compleja con los años</li>
          <li>Registrar comida casera es tedioso (ingrediente por ingrediente)</li>
          <li>Muchos datos de la base de datos introducidos por usuarios (pueden tener errores)</li>
        </ul>

        <h3>Ideal Para</h3>
        <p>Usuarios que comen muchos <strong>productos envasados</strong> (el escáner de código de barras es muy útil).</p>

        <h2>3. Yazio</h2>
        <p><strong>Precio:</strong> Gratis (versión PRO: ~6.99€/mes)</p>
        <p><strong>Disponible en:</strong> iOS y Android</p>

        <h3>Lo Mejor</h3>
        <ul>
          <li>Diseño muy limpio y fácil de usar</li>
          <li>Planes de comida y recetas incluidas</li>
          <li>Seguimiento de ayuno intermitente</li>
          <li>Buena base de datos de alimentos en español</li>
        </ul>

        <h3>Lo Peor</h3>
        <ul>
          <li>Muchas funciones bloqueadas en versión gratuita</li>
          <li>No tiene reconocimiento por foto con IA</li>
          <li>Recetas premium solo con suscripción</li>
        </ul>

        <h3>Ideal Para</h3>
        <p>Personas que quieren <strong>planes de comida</strong> además de contar calorías.</p>

        <h2>4. FatSecret</h2>
        <p><strong>Precio:</strong> Gratis (premium: ~6.49€/mes)</p>
        <p><strong>Disponible en:</strong> iOS y Android</p>

        <h3>Lo Mejor</h3>
        <ul>
          <li>Completamente gratis para funciones básicas</li>
          <li>Sin anuncios agresivos</li>
          <li>Diario de comidas simple y funcional</li>
          <li>Comunidad y recetas compartidas</li>
        </ul>

        <h3>Lo Peor</h3>
        <ul>
          <li>Interfaz anticuada comparada con la competencia</li>
          <li>Base de datos más pequeña que MyFitnessPal</li>
          <li>Sin IA ni reconocimiento de imágenes</li>
        </ul>

        <h3>Ideal Para</h3>
        <p>Personas que buscan algo <strong>100% gratuito</strong> sin complicaciones.</p>

        <h2>5. Lifesum</h2>
        <p><strong>Precio:</strong> Gratis (premium: ~9.99€/mes)</p>
        <p><strong>Disponible en:</strong> iOS y Android</p>

        <h3>Lo Mejor</h3>
        <ul>
          <li>Diseño premium y motivador</li>
          <li>Planes de dieta variados (keto, vegano, etc.)</li>
          <li>Valoración nutricional de cada comida</li>
        </ul>

        <h3>Lo Peor</h3>
        <ul>
          <li>La versión gratuita es muy limitada</li>
          <li>Casi todo requiere suscripción</li>
          <li>Caro comparado con alternativas</li>
        </ul>

        <h3>Ideal Para</h3>
        <p>Personas que no les importa pagar y quieren una <strong>experiencia premium</strong>.</p>

        <h2>Comparativa Final</h2>

        <table class="comparison-table">
          <thead>
            <tr>
              <th>App</th>
              <th>IA / Foto</th>
              <th>Gratis</th>
              <th>Entrenamientos</th>
              <th>Recetas</th>
              <th>Español</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Wayo</strong></td>
              <td>✅ Sí</td>
              <td>✅</td>
              <td>✅</td>
              <td>✅</td>
              <td>✅</td>
            </tr>
            <tr>
              <td><strong>MyFitnessPal</strong></td>
              <td>❌ No</td>
              <td>⚠️ Limitado</td>
              <td>❌</td>
              <td>⚠️</td>
              <td>✅</td>
            </tr>
            <tr>
              <td><strong>Yazio</strong></td>
              <td>❌ No</td>
              <td>⚠️ Limitado</td>
              <td>❌</td>
              <td>✅</td>
              <td>✅</td>
            </tr>
            <tr>
              <td><strong>FatSecret</strong></td>
              <td>❌ No</td>
              <td>✅</td>
              <td>❌</td>
              <td>⚠️</td>
              <td>✅</td>
            </tr>
            <tr>
              <td><strong>Lifesum</strong></td>
              <td>❌ No</td>
              <td>❌ Muy limitado</td>
              <td>❌</td>
              <td>⚠️</td>
              <td>✅</td>
            </tr>
          </tbody>
        </table>

        <h2>¿Cuál Elegir?</h2>
        <ul>
          <li><strong>Quieres la más fácil:</strong> Wayo (foto y listo)</li>
          <li><strong>Comes mucho envasado:</strong> MyFitnessPal (escáner de barras)</li>
          <li><strong>Quieres planes de comida:</strong> Yazio</li>
          <li><strong>Quieres 100% gratis:</strong> FatSecret</li>
          <li><strong>No te importa pagar:</strong> Lifesum</li>
        </ul>

        <h2>Preguntas frecuentes</h2>
        <div class="faq-section">
          <h4>¿Cuál es la mejor app para contar calorías gratis?</h4>
          <p>Si quieres rapidez, Wayo es la mejor opción porque permite contar calorías con una foto. Si prefieres registrar productos envasados, MyFitnessPal sigue teniendo una base de datos muy grande. Si buscas algo clásico y gratuito, FatSecret es una alternativa simple.</p>

          <h4>¿Hay apps gratis para contar calorías con foto?</h4>
          <p>Sí. Wayo está pensada para escanear comidas con IA: haces una foto del plato y la app estima calorías y macros sin buscar cada ingrediente a mano.</p>

          <h4>¿Es mejor contar calorías con app o hacerlo manualmente?</h4>
          <p>Una app reduce errores y ahorra tiempo, sobre todo si comes platos caseros. Hacerlo manualmente funciona, pero suele ser más lento y aumenta la probabilidad de abandonar.</p>
        </div>

        <div class="cta-box">
          <h3>📸 Prueba Wayo: Contar Calorías con una Foto</h3>
          <p>Sin pesar. Sin buscar. Sin escribir. Solo hazle una foto a tu comida y <strong>Wayo</strong> hace el resto.</p>
          <p><a href="https://wayoai.app/download" class="cta-button">Descargar Wayo Gratis</a></p>
        </div>
      </div>
    `
  }
];
